import moment from "moment";
import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import rangeImage from "../../images/Group 21793.svg";
import { APIDateFormat } from "../Dashboard/DashboardVariables";

function EmployeeLeaveInforModal(props) {
	const endDate = moment(props.leaveData.end).format(APIDateFormat);
	const startDate = moment(props.leaveData.start).format(APIDateFormat);
	const diffTime = Math.abs(props.leaveData.end - props.leaveData.start);
	const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

	return (
		<div>
			<Modal isOpen={props.modal} toggle={props.toggle}>
				<ModalHeader>{props.leaveData.title}</ModalHeader>
				<ModalBody>
					<h6>planned leaves: {diffDays}</h6>
					<div className="d-flex flex-column">
						<span>Duration</span>
						<span>{startDate}</span>
						<div>{<img src={rangeImage} alt="ohSnap" />}</div>
						<span>{endDate}</span>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
}

export default EmployeeLeaveInforModal;
